import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';

@Injectable()
export class ProDevService{

	constructor(private httpclientService: HttpClientService){}


	getProDev(page) {
		return this.httpclientService.getMethod({
			url: '/web/workshop/queryWorkshopList/' + page,
		})
	}

	getProDevDetail(id) {
		return this.httpclientService.getMethod({
			url: '/web/workshop/queryWorkshopById/' + id,
		})
    }
    
    // 获取视频列表
    getVideoList(data: {
        channel?: string,
        pageIndex: number,
        pageSize?: number
    }){
        return this.httpclientService.getMethod({
			url: `/web/video/speech/list?channel=${data.channel || 'Webinar'}&page=${data.pageIndex}&rows=${data.pageSize || 10}`,
		})
    }

    // 获取视频详情
    getVideoDetail(id: number){
        return this.httpclientService.postMethod({
            url: `/web/video/speech/detail/${id}`,
        });
    }

    // 获取视频留言
    getVideoComment(id: number, pageIndex: number, pageSize = 10){
        return this.httpclientService.getMethod({
            url: `/web/video/speech/comments/list?page=${pageIndex}&rows=${pageSize}&videoSpeechId=${id}`,
        });
    }

    // 提交视频留言
    comment(data: {
        userRole?: number | string  // 游客角色，会员评论可不传
        comments: string            // 内容
        videoSpeechId: number       // 宣讲视频ID
    }){
        return this.httpclientService.postMethod({
            url: '/web/video/speech/comments/put',
            data,
        });
    }

    // 视频讲解员回复留言
    replyComment(data: {
        parentId: number | string   // 评论ID
        comments: string            // 内容
    }){
        return this.httpclientService.postMethod({
            url: '/web/video/speech/comments/reply',
            data,
        });
    }

	// 获取常见问答列表
	getQuestions(pageIndex: number, pageSize = 10){
		return this.httpclientService.getMethod({
			url: `/web/question/question/list?page=${pageIndex}&rows=${pageSize}`,
		})
	}

	// 提出问题
	postQuestion(question: string){
		return this.httpclientService.postMethod({
			url: '/web/question/question/put',
			data: {
				question
			},
		})
	}
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/service/pro-dev.service.ts